import { Box, xcss } from '@atlaskit/primitives';
import React, { useRef, useEffect } from 'react';

import { BORDER_ORANGE, BORDER_GREEN, BORDER_BLUE, BORDER_PURPLE } from './constants.ts';

const containerStyles = xcss({
  position: 'relative',
  display: 'block',
  width: '100%'
});

const innerContainerStyles = xcss({
  position: 'relative',
  borderRadius: 'radius.small',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  width: '100%',
  height: '100%'
});

const borderStyles = xcss({
  position: 'absolute',
  inset: '0',
  borderRadius: 'radius.xsmall',
  background: `conic-gradient(from var(--database-rovo-gradient-angle, 0deg),
    ${BORDER_ORANGE} 25%,
    ${BORDER_GREEN} 25% 50%,
    ${BORDER_BLUE} 50% 75%,
    ${BORDER_PURPLE} 75% 100%)`,
  zIndex: '1'
});

const glowStyles = xcss({
  inset: '-6px',
  filter: 'blur(8px)',
  opacity: 0.15
});

const contentStyles = xcss({
  position: 'relative',
  backgroundColor: 'elevation.surface.overlay',
  borderRadius: 'radius.xsmall',
  margin: 'space.025',
  zIndex: 'card'
});

export const AiFirstCreationLoadingWrapper = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  // custom animation logic in order to avoid using keyframe from emotion
  useEffect(() => {
    let frame = 0;
    let angle = 0;
    const animate = () => {
      angle = (angle + 1) % 360;
      if (ref.current) {
        ref.current.style.setProperty('--database-rovo-gradient-angle', `${angle}deg`);
      }
      frame = requestAnimationFrame(animate);
    };
    animate();
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <Box xcss={containerStyles}>
      <Box xcss={innerContainerStyles} ref={ref}>
        <Box xcss={[borderStyles, glowStyles]} />
        <Box xcss={borderStyles} />
        <Box xcss={contentStyles}>{children}</Box>
      </Box>
    </Box>
  );
};
